import React from 'react';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../constants/ActionTypes';
import {
    availableFontSizes,
    availableFontStyle,
    availableTextDecoration,
    availableLineHeight,
    availableTextAlign
} from '../../constants/availableFonts';

const initialState = {
    availableFontSizes: availableFontSizes,
    availableFontStyle: availableFontStyle,
    availableTextDecoration: availableTextDecoration,
    availableLineHeight: availableLineHeight,
    availableTextAlign: availableTextAlign
};

const filterBarReducer = (state = initialState, action) => {
    return state;
};

export default filterBarReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/filterbar.js